module.exports = __webpack_public_path__ + "static/media/moile-viewdecor3.002cc8c6.png";